/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Actions/InputValidationActions" />
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { InputDetails, InputMetadata } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointsEditorPanelInterfaces";

export class InputValidationActions extends ActionsHubBase {
    public static getKey(): string {
        return "InputValidationActionsKey";
    }

    public initialize(instanceId?: string): void {
        this._addInputs = new Action<InputDetails[]>();
        this._removeInputs = new Action<string[]>();
        this._validateInputState = new Action<InputMetadata>();
        this._setInputError = new Action<InputMetadata>();
    }

    public get addInputs(): Action<InputDetails[]> {
        return this._addInputs;
    }

    public get removeInputs(): Action<string[]> {
        return this._removeInputs;
    }

    public get validateInputState(): Action<InputMetadata> {
        return this._validateInputState;
    }

    public get setInputError(): Action<InputMetadata> {
        return this._setInputError;
    }

    private _addInputs: Action<InputDetails[]>;
    private _removeInputs: Action<string[]>;
    private _validateInputState: Action<InputMetadata>;
    private _setInputError: Action<InputMetadata>;
}
